import React from 'react';
import styles from './ServiceTag.module.css';
import { serviceTagType } from '../../interfaces/serviceTag';
import { styleHelper } from '../../helpers/commonFunctions';

const ServiceTag = ({ loading, data, isSelected, onClick }: {
    loading: boolean;
    data: serviceTagType;
    isSelected: boolean;
    onClick: () => void;
}) => {
    const text = data.title;
    const selected = data.isSelected;
    return (
        <div
            className={`${styles.card_sizing} vas-d-flex vas-align-items-center vas-justify-content-center pointerCursor ${selected ? styles.selected : styles.unselected} ${styles.border_radius}`}
            style={styleHelper({
                color: selected ? 'white' : 'black'
            })}
            onClick={onClick}
        >
            <span className={styles.font_weight}>
                {loading ? (
                    <i
                        className={`vas-spinner-border vas-text-success vas-spinner-border-sm vas-my-1 vas-mx-1 ${styles.loader_size}`}
                    />
                ) : (
                    text?.text
                )}
            </span>
        </div>
    );
};

export default ServiceTag;
